import clsx from 'clsx'
import { Space } from 'component/Space'
import { useEffectOnce } from 'hook/useEffectOnce'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { useEffect, useRef, useState } from 'react'
import { InferenceData } from 'type/inference'
import { Image } from 'ui/preview/Carousel/Image'
import { Video } from 'ui/preview/Carousel/Video'
import pause_svg from 'ui/preview/icon/pause.svg'
import play_svg from 'ui/preview/icon/play.svg'
import refresh_svg from 'ui/preview/icon/refresh.svg'
import { preview } from 'ui/preview/store/PreviewStore'
import css from './Slide.module.scss'

type Props = {
  inference: InferenceData
}

export const Slide = observer(({ inference }: Props) => {
  const current = preview.it.inference
  const is_video = !!inference.video
  const active = inference === current

  const videoRef = useRef<HTMLVideoElement>(null)
  const [goodVideo, setGoodVideo] = useState(false)
  const [goodImage, setGoodImage] = useState(false)
  const [touch, setTouch] = useState(false)
  const [rewind, setRewind] = useState(false)
  const [play, setPlay] = useState(false)

  const PlaySvg = rewind ? refresh_svg : play ? pause_svg : play_svg

  useEffectOnce(() => {
    const element = videoRef.current
    if (!element) return

    element.load()
    element.addEventListener('play', () => {
      setTouch(true)
      setRewind(false)
      setPlay(true)
    })
    element.addEventListener('pause', () => setPlay(false))
    element.addEventListener('ended', () => {
      element.currentTime = 0
      setRewind(true)
    })
  })

  useEffect(() => {
    if (!active) {
      if (videoRef.current) {
        videoRef.current.pause()
        videoRef.current.currentTime = 0
      }
      setTouch(false)
      setRewind(false)
      setPlay(false)
    }
  }, [active])

  const onPlay = useLatestCallback(() => {
    if (!videoRef.current) return
    if (play) void videoRef.current.pause()
    else void videoRef.current.play()
  })

  return <div className={clsx(css.slide, !goodVideo && !goodImage && css.blank)} onClick={onPlay}>
    {is_video && <Video videoRef={videoRef} inference={inference} onGood={setGoodVideo} />}
    {(!is_video || !touch) && <Image inference={inference}
      preview={is_video && goodVideo} onGood={setGoodImage} />}
    {is_video && <Space gap={8} pin={[0, 0, 0, 0]} center>
      <div className={clsx(css.play, play && css.busy)} onClick={onPlay}>
        <PlaySvg />
      </div>
    </Space>}
  </div>
})
